module.exports = __webpack_public_path__ + "img/inner-page-bg.89588484.jpg";